import { ILocationState } from 'interfaces';
import { useLocation } from 'react-router-dom';

export default function usePreviousLocation() {
  const location = useLocation<ILocationState>();
  return location || {};
}
